<template>
  <div class="content content--quiz">
    <MyHeader :breadcrumbItems="
      [

        {
          name: section.name,
          path: `/${$route.params.companySlug}/quizzes`
        },
        {
          name: quiz.name,
          path: $route.path
        }
      ]"/>

    <div class="container main-content">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
import MyHeader from "@/components/general/Header";
export default {
  name: "Quiz",
  components: {MyHeader},
  mounted() {
    this.$store.dispatch('getQuiz', this.$route.params.id)
  },
  watch: {
    '$store.getters.quizLoaded'(val) {
      if (val) {
        window._paq.push(['setDocumentTitle', this.quiz.name]);
        window._paq.push(['trackPageView']);
      }
    }
  },
  computed: {
    quiz() {
      return this.$store.getters.quiz
    },
    section() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'QuizIndex'
      })
    },
  }
}
</script>

<style scoped>

</style>